<template>
    <section id="dnarepair1">
        <div class="container py-5">
            <div class="col-12 my-5 w-title"><h3 class="text-title-content text-secondary wow slideInDown">{{SectionDnaRepair1.title}}<br>{{SectionDnaRepair1.title2}}</h3></div>
            <div class="row mb-5 d-flex flex-wrap">
                <div class="col-lg-3 col-6 wow slideInLeft">
                    <div class="card border-0 bg-transparent text-center hover-img">
                        <img src="assets/img/lelah-lesu.jpg" class="card-img-top rounded-circle border border-success border-4" alt="...">
                        <div class="card-body px-0">
                            <p class="card-text fs-6 lh-2">{{SectionDnaRepair1.desc1}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-6 wow slideInUp">
                    <div class="card border-0 bg-transparent text-center hover-img">
                        <img src="assets/img/kerut-kulit.jpg" class="card-img-top rounded-circle border border-success border-4" alt="...">
                        <div class="card-body px-0">
                            <p class="card-text fs-6 lh-2">{{SectionDnaRepair1.desc2}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-6 wow slideInUp">
                    <div class="card border-0 bg-transparent text-center hover-img">
                        <img src="assets/img/lemak-perut.jpg" class="card-img-top rounded-circle border border-success border-4" alt="...">
                        <div class="card-body px-0">
                            <p class="card-text fs-6 lh-2">{{SectionDnaRepair1.desc4}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-6 wow slideInRight">
                    <div class="card border-0 bg-transparent text-center hover-img">
                        <img src="assets/img/stress.jpg" class="card-img-top rounded-circle border border-success border-4" alt="...">
                        <div class="card-body px-0">
                            <p class="card-text fs-6 lh-2">{{SectionDnaRepair1.desc3}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SectionDnaRepair1',

  data(){
   return{
     lastScrollPosition: 0,
     SectionDnaRepair1:{
         title: null,
         title2:null,
         desc1: null,
         desc2: null,
         desc3: null,
         desc4: null
         }
   }
 },

  mounted(){
    axios.get(`../../lang.json`).then(response => {
            let dataSectionDnaRepair1
            if (localStorage.getItem('lang_nad') == 'id'){
                dataSectionDnaRepair1 = response.data.id[0];
            } else if(localStorage.getItem('lang_nad') == 'en'){
                dataSectionDnaRepair1= response.data.en[0];
            }
            this.SectionDnaRepair1.title = dataSectionDnaRepair1.SectionDnaRepair1.title
            this.SectionDnaRepair1.title2 = dataSectionDnaRepair1.SectionDnaRepair1.title2
            this.SectionDnaRepair1.desc1 = dataSectionDnaRepair1.SectionDnaRepair1.desc1
            this.SectionDnaRepair1.desc2 = dataSectionDnaRepair1.SectionDnaRepair1.desc2
            this.SectionDnaRepair1.desc3 = dataSectionDnaRepair1.SectionDnaRepair1.desc3
            this.SectionDnaRepair1.desc4 = dataSectionDnaRepair1.SectionDnaRepair1.desc4
            })

    window.addEventListener('scroll', this.onScroll)
  }
}
</script>
